export { default } from 'webapp/routes/routines/detail';
